import {Button} from "@material-ui/core";
import React, {useEffect, useRef} from "react";
import styles from './FileInput.module.scss';
import FilesSelectedState from "./components/filesSelectedState";
import {FieldProps} from "formik";
import {IProduct} from "../../../../../data/interfaces/products";
import {IDocumentFile} from "../../../../../data/interfaces/documents";


export interface IFileInputProps extends FieldProps {
  setState?: (files: any[]) => void;
  initialFiles?: IDocumentFile[];
  product?: IProduct;
  loadInitialFiles?: any;
  downloadFile?: any;
}

// skipFilesCheck
const FileInput = (props: IFileInputProps) => {
  const files = props.initialFiles || props.field.value || [];
  const fileInputRef = useRef();
  useEffect(() => {
    if (props.product && props.loadInitialFiles && !props.product.document) {
      props.loadInitialFiles(props.product.id);
    }
  }, [props.product ? props.product.id : '']);
  useEffect(() => {
    props.form.setFieldValue('skipFilesCheck', props.initialFiles && props.initialFiles.length > 0, false);
  }, [props.initialFiles]);
  return (
    <span className={styles.FileInput}>
      <input ref={fileInputRef}
             name={props.field.name}
             onBlur={props.field.onBlur}

             className={styles.uploadInput}
             type="file"
             accept=".txt,.gif,.bmp,.png,.jpg,.jpeg,.doc,.docx,.pdf,.xps"
             onChange={(e) => {
               const files = [...((e.target.files as any) || [])];
               props.field.onChange({
                 target: {
                   name: props.field.name,
                   value: files,
                 },
               });
             }}/>
      <FilesSelectedState files={files} downloadFile={props.downloadFile}/>
      <Button className={styles.uploadButton}
              onClick={() => {
                if (fileInputRef && fileInputRef.current) {
                  (fileInputRef.current as any).click();
                }
              }}>בחר קובץ</Button>
    </span>
  );
};

FileInput.defaultProps = {
  setState: () => {
  }
};

export default FileInput;
